import React from 'react';
import { Typography } from '../../../../components';
import { PublicLinkItemData } from '../types';
import { calculateIncome } from '../utils';
import { InfoCircle } from '../../../../components/icons';

interface IncomeCellProps {
  item: PublicLinkItemData;
}

const IncomeCell: React.FC<IncomeCellProps> = ({ item }) => {
  // Проверяем доступность данных транзакций
  const hasTransactionStats =
    item.transactions_statistic && item.transactions_statistic.total !== undefined;

  // Если нет данных о транзакциях, не показываем ячейку
  if (!hasTransactionStats) {
    return (
      <div className="flex gap-0.5 items-center w-full">
        <Typography variant="body3" className="text-zinc-500">
          —
        </Typography>
      </div>
    );
  }

  // Показываем полный доход из transactions_statistic.total (БЕЗ вычета комиссии)
  const revenue = parseFloat(String(item.transactions_statistic?.total || 0));
  // Доход партнёра с RevShare = revenue * (commission / 100)
  const partnerIncome = calculateIncome(revenue, item.commition);
  // Процент комиссии партнёра
  const commission = 0;

  return (
    <div className="flex gap-0.5 items-center w-full">
      <div className="flex gap-1 items-center">
        <Typography variant="label2SemiBold" className="text-auth-ink">
          {revenue.toFixed(2)}
        </Typography>
        <Typography variant="body3" className="text-zinc-500">
          ({commission}%)
        </Typography>
      </div>
      {/* <InfoCircle/> */}
    </div>
  );
};

export default IncomeCell;
